<template lang="html">
    <div>
        <div class="form-group d-flex">
            <div class="col-sm-12">
                <label>Name</label>
                <div class="d-flex align-items-center">
                    <input type="text" class="w-50" v-model="salesChannel.name" placeholder="Name here" :disabled="blockNameChange">
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <h5>Advanced Settings</h5>
        </div>

        <div class="col-sm-12">
            <div class="col-sm-12">
                <div class="d-flex justify-content-between mb-2 align-items-center">
                    <span class="fs-small bold">Allow to book Extras</span>
                    <toggle-button v-model="salesChannel.isAllowedSellComponents" :labels="{checked: 'Yes', unchecked: 'No'}" />
                </div>

                <div class="d-flex justify-content-between mb-2 align-items-center">
                    <span class="fs-small bold" :class="{'opacity-50': disableTranpsortOption}">Allow to book Transports</span>
                    <toggle-button v-model="salesChannel.isAllowedSellTransports" :disabled="disableTranpsortOption"  :labels="{checked: 'Yes', unchecked: 'No'}" />
                </div>

                <div class="d-flex justify-content-between mb-2 align-items-center">
                    <span class="fs-small bold">Send notification on new booking</span>
                    <toggle-button v-model="salesChannel.notificationNewBooking"  :labels="{checked: 'Yes', unchecked: 'No'}" />
                </div>

                <div class="d-flex justify-content-between mb-2 align-items-center" v-if="hasInvoiceSystem && salesChannel.channelType === 101">
                    <div :class="{'opacity-50': !salesChannel.notificationFlags.automaticInvoice.canBeEnabled}">
                        <span class="fs-small bold">Automatic invoice</span>
                    </div>
                    <div>
                        <toggle-button
                            :value="salesChannel.notificationFlags.automaticInvoice.state === 1"
                            @input="val => salesChannel.notificationFlags.automaticInvoice.state = val ? 1 : 0"
                            :disabled="!salesChannel.notificationFlags.automaticInvoice.canBeEnabled"
                            :labels="{checked: 'Yes', unchecked: 'No'}"
                        />
                    </div>
                </div>

                <div class="d-flex justify-content-between mb-2 align-items-center" v-if="showTicketFormatPicker">
                    <div class="d-flex flex-column">
                        <span class="fs-small bold">Ticket format</span>
                    </div>
                    <div>
                        <v-select :options="getTicketTypes" v-model="salesChannel.ticketType_helper_selected" @input="ticketTypeChanged"></v-select>
                    </div>
                </div>

                <div class="d-flex justify-content-between mb-2 align-items-center">
                    <div class="d-flex flex-column">
                        <span class="fs-small bold">Origins</span>
                    </div>
                    <div>
                        <v-select label="name" :options="originsOptions" v-model="origin" :reduce="origin => origin.id" @input="originChanged"></v-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import origins from '@/store/modules/origins'
import { mapActions, mapGetters} from 'vuex'

export default {
	data() {
		return {
			origin: {
				name: 'None',
				id: 0
			}
		}
	},
	created() {
		this.origin.name = !!this.salesChannel.origin ? this.salesChannel.origin : 'None';
		this.origin.id = !!this.salesChannel.originId ? this.salesChannel.originId : null;
	},
    props: {
        salesChannel:{
            type: Object
        }
    },
    computed: {
        ...mapGetters([
            'getInvoicingOptions',
            'getTicketTypes',
            'getCompanySettings',
            'getShowInvoiceOption',
			'getOrigins',
        ]),
		originsOptions() {
            const origins = this.getOrigins;
			const emptyOrigin = {
				name: 'None',
				id: 0
			}

			return [emptyOrigin, ...origins];
		},
        blockNameChange() {
            let blockedChannelTypes = new Array(50, 101);
            return blockedChannelTypes.includes(this.salesChannel.channelType) || this.salesChannel.isOTA;
        },
        hasInvoiceSystem() {
            return this.getShowInvoiceOption? this.getShowInvoiceOption : false;
        },
        hasInvoiceSystemActive() {
            return this.getCompanySettings.settingsPresets.invoiceSystem && this.getCompanySettings.settingsPresets.invoiceSystem.isActive;
        },
        showTicketFormatPicker() {
            if (this.salesChannel.channelType === 101 || this.salesChannel.channelType === 50) {
                return false;
            } else {
                return true;
            }
        },
        disableTranpsortOption() {
            return false;
        }
    },
    methods: {
        ...mapActions([
            'closeModal',
        ]),
        ticketTypeChanged() {
            this.salesChannel.ticketType = this.salesChannel.ticketType_helper_selected.id;
        },
		originChanged(origin) {
			this.salesChannel.origin = origin.name;
			this.salesChannel.originId = origin.id === 0 ? null : origin.id;
		},
    },
    components:{
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// salesChannelForm.vue?677176ff